import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../images/logo.png";
import "./Header.css";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleToggle = () => setMenuOpen((open) => !open);
  const handleClose = () => setMenuOpen(false);

  return (
    <header className="header">
      <div className="logo">
        <Link to="/" onClick={handleClose}>
          <img src={logo} alt="Naman Finlease Logo" className="logo-img" />
        </Link>
      </div>
      <button className="nav-toggle" onClick={handleToggle} aria-label="Toggle navigation">
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>
      <nav className={`nav${menuOpen ? " open" : ""}`}>
        <Link className="nav-link" to="/" onClick={handleClose}>Home</Link>
        <Link className="nav-link" to="/about" onClick={handleClose}>About</Link>
        <Link className="nav-link" to="/service" onClick={handleClose}>Service</Link>
        <Link className="nav-link" to="/career" onClick={handleClose}>Career</Link>
        <Link className="nav-link" to="/repay" onClick={handleClose}>Repay</Link>
        <Link className="nav-link" to="/contact" onClick={handleClose}>Contact</Link>
      </nav>
    </header>
  );
};

export default Header;
